import React, { useEffect, useState } from 'react';
import './MainContent.css';
import heroImage from '../images/hero-image.png';
import { Link } from "react-router-dom";

const MainContent = () => {
  const [postsRecientes, setPostsRecientes] = useState([]);
  const [ranking, setRanking] = useState([]);
  const [mostrarModalServidor, setMostrarModalServidor] = useState(false);

  useEffect(() => {
    fetch("/api/posts")
      .then((res) => res.json())
      .then((data) => {
        setPostsRecientes(Array.isArray(data) ? data.slice(0, 3) : []);
      })
      .catch((error) => {
        console.error("Error cargando noticias recientes:", error);
        setPostsRecientes([]);
      });
  }, []);

  useEffect(() => {
    fetch("/api/economia/ranking")
      .then((res) => res.json())
      .then((data) => {
        setRanking(Array.isArray(data) ? data.slice(0, 10) : []);
      })
      .catch((error) => {
        console.error("Error cargando ranking:", error);
        setRanking([]);
      });
  }, []);

  return (
    <main className="main-container">

      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${heroImage})`
        }}
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <span className="hero-badge">🟢 Servidor Operativo</span>

            <h1>
              Vive tu historia en
              <span> Club Oficial RP</span>
            </h1>

            <p>
              Economía real, trabajos, policías,
              empresas, bandas y eventos semanales.
            </p>

            <div className="hero-buttons">
              <button
                className="btn-primary"
                onClick={() => setMostrarModalServidor(true)}
              >
                ▶ Conectarse al Servidor
              </button>

              <button
                className="btn-secondary"
                onClick={() =>
                  window.open("https://discord.gg/FP7qx9kpTw", "_blank")
                }
              >
                💬 Entrar al Discord
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="stat-card">
          <div className="stat-number">124/200</div>
          <div className="stat-title">Jugadores en línea</div>
          <div className="stat-desc">Conectados ahora</div>
        </div>

        <div className="stat-card">
          <div className="stat-number">18</div>
          <div className="stat-title">Policías activos</div>
          <div className="stat-desc">En servicio</div>
        </div>

        <div className="stat-card">
          <div className="stat-number">42</div>
          <div className="stat-title">Empresas registradas</div>
          <div className="stat-desc">Negocios activos</div>
        </div>

        <div className="stat-card">
          <div className="stat-number">99.9%</div>
          <div className="stat-title">Uptime</div>
          <div className="stat-desc">Este mes</div>
        </div>
      </section>

      <section className="dashboard-grid">
        <div className="dashboard-card">
          <div className="card-header">
            Noticias recientes
          </div>

          {postsRecientes.length === 0 ? (
            <p>No hay noticias recientes.</p>
          ) : (
            postsRecientes.map((post) => (
              <Link
                to={`/noticias/${post.slug}`}
                className="news-item news-item-link"
                key={post.id}
              >
                <img
                  src={post.imagenPortada}
                  alt={post.titulo}
                  className="news-thumb"
                />

                <div>
                  <h3>{post.titulo}</h3>
                  <p>{post.resumen || post.contenido?.substring(0, 80) + "..."}</p>
                </div>
              </Link>
            ))
          )}
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            Top Jugadores
          </div>

          <table className="ranking-table">
            <tbody>
              {ranking.length === 0 ? (
                <tr>
                  <td colSpan="3">No hay ranking disponible.</td>
                </tr>
              ) : (
                ranking.map((jugador, index) => (
                  <tr key={jugador.steamId}>
                    <td>#{index + 1}</td>
                    <td>{jugador.characterName}</td>
                    <td>S/ {Number(jugador.balance).toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            Discord Oficial
          </div>

          <div className="discord-widget">
            <iframe
              src="https://discord.com/widget?id=455189362033033237&theme=dark"
              width="100%"
              height="400"
              allowTransparency="true"
              frameBorder="0"
              sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
              title="Discord Widget"
            />
          </div>
        </div>
      </section>
            {mostrarModalServidor && (
        <div
          className="server-modal-overlay"
          onClick={() => setMostrarModalServidor(false)}
        >
          <div
            className="server-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>🎮 Conectarse al Servidor</h2>

            <p className="server-text">
              Utiliza la siguiente dirección para ingresar a <strong>Club Oficial RP</strong>.
            </p>

            <div className="server-ip-box">
              66.51.99.64:27010
            </div>

            <button
              className="copy-btn"
              onClick={() => {
                navigator.clipboard.writeText("66.51.99.64:27010");
                alert("IP copiada al portapapeles.");
              }}
            >
              📋 Copiar dirección
            </button>

            <div className="server-help">
              <h4>¿Cómo ingresar?</h4>

              <ol>
                <li>Abre <strong>Unturned</strong>.</li>
                <li>Selecciona <strong>Play → Connect</strong>.</li>
                <li>Pega la dirección del servidor.</li>
                <li>¡Disfruta Club Oficial RP!</li>
              </ol>
            </div>

            <button
              className="close-btn"
              onClick={() => setMostrarModalServidor(false)}
            >
              Cerrar
            </button>

          </div>
        </div>
      )}
    </main>
  );
};

export default MainContent;